<template>
  <ui-select
    v-model="innerValue"
    v-bind="$attrs"
    v-on="$listeners"
    :multiple="false"
    :list="list"
  >
    <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope"/>
    </template>
  </ui-select>
</template>

<script>
import UiSelect from './UiSelect.vue'

const VALUES_BY_TYPES = {
  boolean: {
    true: true,
    false: false
  },
  number: {
    true: 1,
    false: 0
  }
}

export default {
  components: {
    UiSelect
  },
  props: {
    value: {
      type: [Number, Boolean, String]
    },
    type: {
      type: String,
      default: 'number',
      validator (type) {
        return ['number', 'boolean'].indexOf(type) !== -1
      }
    },
    trueTitle: {
      type: String,
      default: 'Да'
    },
    falseTitle: {
      type: String,
      default: 'Нет'
    }
  },
  computed: {
    innerValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    list () {
      const values = VALUES_BY_TYPES[this.type]
      return [
        {
          id: values.false,
          name: this.falseTitle
        },
        {
          id: values.true,
          name: this.trueTitle
        }
      ]
    }
  }
}
</script>
